export enum PRODUCT_TYPE {
    CRUISE = 'CRUISE',
    SHUTTLE = 'SHUTTLE',
}

export enum DIRECTION {
    ONEWAY = 'ONEWAY',
    ROUNDTRIP = 'ROUNDTRIP',
}

export enum EMBARCADERE {
    SAVEL = 'MAYRES-SAVEL',
    TREFFORT = 'TREFFORT',
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/booking/booking.constants.ts